import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import PropTypes from 'prop-types';
import Tab from '../Tab/index.js';
import TabNavBar from '../TabNavBar/index.js';
const getNavItems = function (item) {
  if (item === void 0) {
    item = {};
  }
  const {
    props: {
      title,
      eventKey,
      href,
      icon,
      disabled
    }
  } = item;
  return {
    label: title,
    eventKey,
    href,
    icon,
    disabled
  };
};
const getContent = item => item && /*#__PURE__*/React.createElement(Tab.Pane, item.props);
function Tabs(_ref) {
  let {
    children,
    defaultActiveKey = 0,
    uiContext = 'light',
    size = 'default',
    bsStyle = 'tabs',
    alignment = 'center',
    onSelect = () => {},
    ...rest
  } = _ref;
  const navItems = React.Children.map(children, getNavItems);
  const content = React.Children.map(children, getContent);
  return /*#__PURE__*/React.createElement(TabNavBar, Object.assign({
    navItems: navItems,
    defaultActiveKey: defaultActiveKey,
    uiContext: uiContext,
    size: size,
    bsStyle: bsStyle,
    alignment: alignment,
    onSelect: onSelect
  }, rest), /*#__PURE__*/_jsx(Tab.Content, {}, void 0, content));
}
export default Tabs;